import { SupportedLanguage } from '@/enum'
import { DropdownOption } from '@/types'

export const COMPLEXION_OPTIONS: DropdownOption = {
  [SupportedLanguage.English]: ['Very Fair', 'Fair', 'Medium', 'Olive', 'Tan', 'Brown', 'Dark', 'Wheatish'],
  [SupportedLanguage.Hindi]: ['बहुत गोरा', 'गोरा', 'मध्यम', 'जैतूनी', 'सांवला', 'भूरा', 'गहरा', 'गेंहुआ'],
  [SupportedLanguage.Marathi]: ['अत्यंत गोरा', 'गोरा', 'मध्यम', 'ऑलिव्ह', 'तपकिरी', 'ब्राऊन', 'काळा', 'गव्हाळ'],
  [SupportedLanguage.Gujarati]: ['ખૂબ ગોરું', 'ગોરું', 'મધ્યમ', 'ઓલિવ', 'ટેન', 'બ્રાઉન', 'ડાર્ક', 'ઘઉંવર્ણ'],
  [SupportedLanguage.Bengali]: ['খুব ফর্সা', 'ফর্সা', 'মাঝারি', 'জলপাই', 'ট্যান', 'বাদামী', 'গাঢ়'],
  [SupportedLanguage.Telugu]: ['చాలా తెలుపు', 'తెలుపు', 'మధ్యస్థం', 'ఆలివ్', 'టాన్', 'గోధుమ', 'నలుపు', 'గోధుమ వర్ణం'],
  [SupportedLanguage.Kannada]: ['ತುಂಬಾ ಫೇರ್', 'ಫೇರ್', 'ಮಧ್ಯಮ', 'ಆಲಿವ್', 'ಟ್ಯಾನ್', 'ಬ್ರೌನ್', 'ಡಾರ್ಕ್'],
  [SupportedLanguage.Tamil]: [
    'மிகவும் வெளிர் நிறம்', // Very Fair
    'வெளிர் நிறம்', // Fair
    'மிதமான நிறம்', // Medium
    'ஆலிவ் நிறம்', // Olive
    'சுருந்த நிறம்', // Tan
    'பழுப்பு நிறம்', // Brown
    'கருமை நிறம்', // Dark
    'கோதுமை நிறம்', // Wheatish
  ],
  [SupportedLanguage.Odia]: ['ବହୁତ ଉଜ୍ଜ୍ୱଳ', 'ଉଜ୍ଜ୍ୱଳ', 'ମଧ୍ୟମ', 'ଓଲିଭ ରଙ୍ଗ', 'ଟ୍ୟାନ୍', 'ଧୂସର', 'ଗାଢ଼', 'ଗୋଧୂମରଙ୍ଗୀ'],
  [SupportedLanguage.Malayalam]: [
    'വളരെ വെളുത്ത', // Very Fair
    'വെളുത്ത', // Fair
    'ഇടത്തരം', // Medium
    'ഒലിവ്', // Olive
    'ടാൻ', // Tan
    'ബ്രൗൺ', // Brown
    'ഇരുണ്ട', // Dark
    'ഗോതമ്പ്' // Wheatish
  ]
}
